// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

// Importa vue-i18n e as mensagens
import { createI18n } from 'vue-i18n'
import messages from '@/assets/lang'

// Cria a instância do i18n
const i18n = createI18n({
  legacy: false, // Use o modo Composition API

  locale: 'pt', // idioma padrão
  messages
})

// Configura o Vuetify para usar o vue-i18n para tradução
const vuetify = createVuetify({
  lang: {
    t: (key, ...params) => i18n.global.t(key, ...params)
  }
})

export { i18n }
export default vuetify
